import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { PAGE_PATHS } from '@/routes/const';

/** 상세/플로우 헤더: 뒤로 + 제목. 하단 메뉴는 공통 화면 정책을 따른다. */
export default function FullScreenHeader({ title }: { title?: string }) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const goBack = () =>
    window.history.length > 1 ? navigate(-1) : navigate(PAGE_PATHS.HOME);

  return (
    <header className="sticky top-[var(--gp-system-offset,0px)] z-30 flex h-14 items-center gap-2 bg-gp-pink-50/90 px-2 backdrop-blur">
      <button
        type="button"
        onClick={goBack}
        className="grid size-10 place-items-center rounded-full"
        aria-label={t('header.back')}
      >
        <ArrowLeft className="size-5" aria-hidden="true" />
      </button>
      {title && <h1 className="truncate text-h3 font-semibold">{title}</h1>}
    </header>
  );
}
